import React, {useState, useEffect} from "react";
import { StructuredListSkeleton, Link } from "carbon-components-react";
import { useDispatch, useSelector } from "react-redux";
import { EnrollmentType } from "../../components/enums/enrollment-type";
import NewHire from "./new-hire";
import ExistingEmployee from "./existing-employee";
import SelectedAction from "./selected-action";
import { useNavigate } from "react-router";
import { updateEnrollments } from "../../redux/actions/enrollments-actions";
import useMsalApi from "../../components/use-msal-api";
import Initialize from "../../components/initilize";

const Home = () => {
  const enrollments = useSelector(s => s.enrollments);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [callApi] = useMsalApi();
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);


  useEffect(() => {
    if(!Array.isArray(enrollments))
      setLoading(false);
    else {
      Initialize(callApi, dispatch, navigate);
    }

  }, [enrollments])



  return (
    <div className="">
    {loading ? <>
      <div className="font-bold text-3xl">Employee Benefits</div>
      <div className="text-lg mt-2">Please wait while we retrieve your information...</div>
      <div className="my-8">
        <StructuredListSkeleton />
      </div>
    </>
    :
    <>
        {enrollments.enrollmentTypeId === EnrollmentType.NewHire ?
          <NewHire />
          : <>
          {!enrollments.enrollmentTypeId ?
          <ExistingEmployee />
          :
          <SelectedAction />
        }
        </>
      }
    </>
    }

     </div>

  );
};

export default Home;
